import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang } from "@/lib/i18n";

const KEYS = [["top", "home"], ["gallery", "gallery"], ["services", "services"], ["about", "about"]];

const LangToggle = ({ testId, className }) => {
  const { lang, t, setLang } = useLang();
  return (
    <button type="button" className={`lang-btn ${className || ""}`} lang={lang === "en" ? "es" : "en"}
      aria-label={t.nav.langLabel} onClick={() => setLang(lang === "en" ? "es" : "en")} data-testid={testId}>
      <span className="lang-on">{lang.toUpperCase()}</span><span className="lang-sep">/</span><span>{t.nav.langShort}</span>
    </button>
  );
};

const NavLink = ({ id, onHome, children, ...rest }) => {
  if (id === "gallery") return <Link to="/gallery" {...rest}>{children}</Link>;
  if (onHome) return <a href={`#${id}`} {...rest}>{children}</a>;
  return <Link to={id === "top" ? "/" : `/#${id}`} {...rest}>{children}</Link>;
};

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { t } = useLang();
  const onHome = useLocation().pathname === "/";
  return (
    <header data-testid="site-header">
      <div className="wrap">
        <NavLink id="top" onHome={onHome} className="brand" aria-label={t.nav.homeLabel} data-testid="nav-logo">
          <img src="/logo.png" alt="Flowers by Tino" width="84" height="38" />
        </NavLink>
        <nav aria-label={t.nav.main}>
          {KEYS.map(([id, k]) => (
            <NavLink key={id} id={id} onHome={onHome} className="nl" data-testid={`nav-${k}`}>{t.nav[k]}</NavLink>
          ))}
          <LangToggle testId="nav-lang-toggle" className="desk" />
          <NavLink id="inquire" onHome={onHome} className="btn" data-testid="nav-inquire">{t.nav.inquire}</NavLink>
          <button className="menu-btn" type="button" aria-expanded={open} aria-controls="mnav"
            aria-label={open ? t.nav.close : t.nav.open} onClick={() => setOpen(!open)} data-testid="nav-menu-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </nav>
      </div>
      <div id="mnav" className={`mnav ${open ? "open" : ""}`} data-testid="mobile-menu">
        {KEYS.map(([id, k]) => (
          <NavLink key={id} id={id} onHome={onHome} onClick={() => setOpen(false)} data-testid={`mnav-${k}`}>{t.nav[k]}</NavLink>
        ))}
        <div className="mnav-lang"><LangToggle testId="mnav-lang-toggle" /></div>
      </div>
    </header>
  );
};
